// Types
import { ElementSize } from '../types/element-size';

// Constants
import { SIZE_MEASUREMENT } from '../constants/common';

export const getMeasurementBySize = (size: ElementSize): { height: number; width: number } => {
  return SIZE_MEASUREMENT[size] ? SIZE_MEASUREMENT[size] : SIZE_MEASUREMENT[ElementSize.MD]
};
